import { getToken } from "js/formatting/getToken";
import config from "config/config";

export async function depricated_getPaymentProfile(UserId) {
  let url =
    config.REG_API_BASE_URL + "/Payment/getpaymentprofile?UserId=" + UserId;

  const response = await fetch(url, {
    headers: {
      Authorization: `bearer ${getToken()}`,
    },
  });
  if (!response.ok) {
    throw response;
  } else {
    const data = await response.json();
    return data;
  }
}
